import React from "react";
import "./Maintenance";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import DenseTable from "../../Dashboard/RenderTable";
import { getKeyValueData } from "../../../utils/graph_service";
import RenderChart from "../../common/Chart/RenderChart";
import camelCaseKeys from "camelcase-keys";
import { SECTIONS } from "../../../constants/appConstants";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
	AppBar,
	Dialog,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Toolbar,
	Tooltip,
	Typography
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import {
	GetSectionPermission,
	getSynchStatus,
	PaperComponent
} from "../../../utils/helper";
import { IoMdCloseCircleOutline } from "react-icons/io";

const CData = [
	{ key: "IncidentCategory", name: "Incident Category" },
	{ key: "Description", name: "Description", width: 450 },
	{ key: "CompletionDate", name: "Completion Date" },
	{ key: "Location", name: "Location" },
	{ key: "Priority", name: "Priority" },
	{ key: "PropertyName", name: "Property Name" },
	{ key: "ReceivedDate", name: "Received Date", format: "DateTime" },
	{ key: "ReportedBy", name: "Reported By" },
	{ key: "ReceivedTime", name: "Received Time" },
	{ key: "Status", name: "Status" }
	// { key: "Action", name: "Action" },
];
const configData = {
	trend: { type: 4, key: "receivedDate" },
	columns: [
		{
			key: "",
			name: "Incident Category",
			type: "count",
			filters: [{ key: "IncidentCategory", values: "All" }],
			color: "#E59400",
			sortOrder: 0
		}
		// {
		//   key: "",
		//   name: "Priority 2",
		//   type: "count",
		//   filters: [{ key: "priority", values: ["Priority 2"] }],
		//   color: "#007300",
		//   sortOrder: 1,
		// },
		// {
		//   key: "",
		//   name: "Priority 3",
		//   type: "count",
		//   filters: [{ key: "priority", values: ["Priority 3"] }],
		//   color: "#1A8FBF",
		//   sortOrder: 2,
		// },
		// {
		//   key: "",
		//   name: "No Priority",
		//   type: "count",
		//   filters: [{ key: "priority", values: ["No Priority"] }],
		//   color: "#007bff",
		//   sortOrder: 2,
		// },
	],
	isRepeated: true,
	autoGenerate: { key: "incidentCategory", filters: [] }
};

class IncidentsTable extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			IncidentReportingList: [],
			resDataGraph: {},
			rawData: [],
			IsConditionOpen: false,
			FiltersView: false,
			syncStatus: "NA"
		};
	}

	componentDidMount() {
		this.GetIncidentReportingDataByDate(
			this.props.propertyId,
			this.props.startDate,
			this.props.endDate
		);
	}
	componentWillReceiveProps(newProps) {
		if (
			newProps.propertyId != this.props.propertyId ||
			newProps.startDate != this.props.startDate ||
			newProps.endDate != this.props.endDate
		) {
			this.GetIncidentReportingDataByDate(
				newProps.propertyId,
				newProps.startDate,
				newProps.endDate
			);
		}
	}

	/** incident report data */
	GetIncidentReportingDataByDate = (propertyId, startDate, endDate) => {
		const params = {
			propertyId: propertyId,
			startDate: startDate,
			endDate: endDate
		};

		apiRequest({
			url: API_URL.dashBoard.IncidentReportingDetailsByDate,
			params
		}).then(({ data: IncidentReportingData, syncStatus: syncStatus }) => {
			let resDataGraph = {};

			if (this.props.source == "SecurityAndOperations") {
				resDataGraph = getKeyValueData(
					camelCaseKeys(IncidentReportingData || []),
					configData,
					true
				);
			}

			this.setState({
				IncidentReportingList: camelCaseKeys(IncidentReportingData),
				resDataGraph: resDataGraph,
				startDate: startDate,
				endDate: endDate,
				rawData: IncidentReportingData,
				syncStatus: ((syncStatus || [])[0] || {}).SyncStatus
			});
		});
	};

	GetPropsForData = responseData => {
		const columns = [
			{
				key: "receivedDate",
				name: "Received Date"
			},
			{
				key: "incidentCategory",
				name: "Incident Category"
			},
			{
				key: "priority",
				name: "Priority"
			},
			{
				key: "location",
				name: "Location"
			},
			{
				key: "status",
				name: "Status"
			}
		];

		return {
			data: responseData,
			columns: columns
		};
	};

	getDetailByAttributeAndType = () => {
		// let FilterKeys;
		// var RawData = [];
		// FilterKeys = ["Priority 1", "Priority 2", "Priority 3", "No Priority"];
		// var SortedRawData = this.state.rawData;

		// let outPut;
		// FilterKeys.map((item) => {
		//   outPut = SortedRawData.filter((value) => value.priority == item);
		//   RawData.push({ type: outPut, title: item });
		// });

		// console.log("---", RawData);

		this.setState({
			// SortedRawData: SortedRawData,
			IsConditionOpen: true,
			FiltersView: false,
		});
	};

	render() {
		const SECURITY_INCIDENTS = GetSectionPermission(
			SECTIONS.SECURITY_AND_OPERATION,
			SECTIONS.SECURITY_INCIDENTS
		);

		const {
			IncidentReportingList,
			resDataGraph,
			IsConditionOpen,
			FiltersView
		} = this.state;

		return (
			<>
				{this.props.source == "maintenance" ? (
					<div>
						<table id={"IncidentReportLog"}>
							<thead>
								<tr className={"blue-custom-title"}>
									<th colSpan={4}>{"Security Incident Report "}</th>
								</tr>
								<tr
									className={"blue-custom-title"}
									style={{ borderTop: "3px solid #FFFFFF", textAlign: "left" }}
								>
									<th>{" Incident ID"}</th>
									<th>{" Incident Category"}</th>
									<th>{" Reported By"}</th>
									<th>{" Status"}</th>
								</tr>
							</thead>
							<tbody>
								{(IncidentReportingList || []).map((item, index) => (
									<tr key={"IncidentReportingList" + index}>
										<td>
											{item["incidentNo"] !== null
												? item["incidentNo"] !== 0
													? item["incidentNo"]
													: "-"
												: "-"}
										</td>
										<td>
											{item["incidentCategory"] !== null
												? item["incidentCategory"]
												: "-"}
										</td>
										<td>
											{item["reportedBy"] !== null ? item["reportedBy"] : "-"}
										</td>
										<td>{item["status"] !== null ? item["status"] : "-"}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				) : null}
				{this.props.source == "SecurityAndOperations" && resDataGraph != {} ? (
					<>
						<div className={"w-100 sec-and-operation-wrapper"}>
							<div className={"w-100  graph-title-hAnds"}>
								<div className={"w-50 pt-5 "}>{"Security Incidents "}</div>

								<div className={"w-50"} style={{ textAlign: "right" }}>
									{SECURITY_INCIDENTS.showData && (
										<>
											<Tooltip title={"View Filters"}>
												<IconButton
													size={"small"}
													onClick={() =>
														this.setState({
															IsConditionOpen: true,
															FiltersView: true,
														})}
												>
													<InfoOutlined
														size={"small"}
														fontSize={"small"}
													/>
												</IconButton>
											</Tooltip>

											<Tooltip title={"View Data"}>
												<IconButton
													size={"small"}
													onClick={this.getDetailByAttributeAndType}
												>
													<VisibilityIcon
														size={"small"}
														fontSize={"small"}
													/>
												</IconButton>
											</Tooltip>
										</>
									)}
								</div>
							</div>

							<RenderChart
								identifier={"IncidentReport"}
								allowDrillDown
								chartConfig={{
									startDate: this.state.startDate,
									endDate: this.state.endDate,
									data: resDataGraph.data,
									type: "DonutChart",
									colors: resDataGraph.colors,
									configuration: configData,
									rawData: IncidentReportingList
								}}
								legends={resDataGraph.legends}
							/>
						</div>
					</>
				) : null}
				{IsConditionOpen && (
					<Dialog
						maxWidth={"md"}
						open={IsConditionOpen}
						onClose={() =>
							this.setState({ IsConditionOpen: false, FiltersView: false })}
						aria-labelledby={"responsive-dialog-title"}
						PaperComponent={PaperComponent}
						fullScreen={!FiltersView}
					>
						<AppBar
							style={{ position: "relative", backgroundColor: "#064473" }}
						>
							<Toolbar>
								<Typography
									variant={"h6"}
									style={{ flex: "1" }}
								>
									{FiltersView ? (
										<DialogTitle
											style={{ cursor: "move" }}
											id={"responsive-dialog-title"}
											className={"white-label"}
										>
											{"Security Incidents"}
											<span className={"condition-label white-label"}>
												{"(Applied filters)\r"}
											</span>
										</DialogTitle>
									) : (
										<DialogTitle
											style={{ cursor: "move" }}
											id={"responsive-dialog-title"}
										>
											{"Security Incidents"}
										</DialogTitle>
									)}
								</Typography>
								<Tooltip title={"Close"}>
									<IconButton
										edge={"end"}
										color={"inherit"}
										onClick={() => {
											this.setState({
												IsConditionOpen: false,
												FiltersView: false
											});
										}}
										aria-label={"close"}
										className={"white-button"}
									>
										<IoMdCloseCircleOutline />
									</IconButton>
								</Tooltip>
							</Toolbar>
						</AppBar>

						<DialogContent>
							<DialogContentText>
								{FiltersView ? (
									configData.columns &&
									configData.columns.map(item => (
										<div className={"col-xs-12"}>
											<div className={"col-xs-12 start-xs condition-heading"}>
												<b>{item.name}</b>{" "}
											</div>
											<div>
												<div className={"col-xs-11 condition-label"}>
													{"Received Date: From "}{this.props.startDate}{" To"}{" "}
													{this.props.endDate}
												</div>
												<div className={"col-xs-11 condition-label"}>
													{"Status: "}{item.filters[0].values}
												</div>
											</div>
										</div>
									))
								) : (
									<>
										<div>
											{/* {SortedRawData.map((item) => ( */}
											<>
												<div>
													<h3>{"All Security Incidents"}</h3>
												</div>
												<hr />
												<DenseTable
													columns={CData}
													data={this.state.rawData}
													config={{
														minRows: 10
													}}
												/>
											</>
											{/* ))} */}
										</div>
									</>
								)}
								{FiltersView ? (
									<span className={"data-sync-text"}>
										{/* {localStorage.getItem("syncStatus")} */}
										{getSynchStatus(this.state.syncStatus)}
									</span>
								) : null}
							</DialogContentText>
						</DialogContent>
					</Dialog>
				)}
			</>
		);
	}
}
export default IncidentsTable;
